import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxAutocompleteModule, DxButtonModule, DxChartModule, DxCheckBoxModule, DxDataGridModule, DxDropDownButtonModule, DxLoadPanelModule, DxPivotGridFieldChooserModule, DxPivotGridModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxTooltipModule } from 'devextreme-angular';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { ScenarioComparisonComponent } from './scenario-comparison.component';
import { ScenarioComparisonRoutingModule } from './scenario-comparison-routing.module';
import { ScenarioCardModule } from './scenario-card/scenario-card.module';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';


@NgModule({
  declarations: [ScenarioComparisonComponent],
  imports: [
    CommonModule,
    DxChartModule,
    ScenarioComparisonRoutingModule,
    DxScrollViewModule,
    DxAutocompleteModule,
    DxDataGridModule,
    DxPopupModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxPivotGridModule,
    DxPivotGridFieldChooserModule,
    DxCheckBoxModule,
    DxLoadPanelModule,
    DxTooltipModule,DxScrollViewModule,
    DxSelectBoxModule,
    BookmarkModule,
    BookmarkNewComponent,
    ScenarioCardModule,
    FiltersGroupModule
  ]
})
export class ScenarioComparisonModule { }
